import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { setHideFooter, setHideHeader } from '../../../redux/modules/topBottomSection/index';
import RegisterDetails from './register-details';
import RegisterInformation from './register-information';

class RegisterTabs extends Component {

  static propTypes = {
    // Action creators
    setHideFooter: PropTypes.func,
    setHideHeader: PropTypes.func
  };

  componentDidMount () {
    this.props.setHideFooter();
    this.props.setHideHeader();
  }

  render () {
    return (
      <div className='register-page page'>
        <div className="register-container">
          <RegisterDetails />
          <RegisterInformation />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setHideFooter: () => dispatch(setHideFooter()),
    setHideHeader: () => dispatch(setHideHeader())
  };
};

export default connect(null, mapDispatchToProps)(RegisterTabs);



/** WEBPACK FOOTER **
 ** ./src/views/register-view/tabs/register-tabs.js
 **/